const { default: axiosInstance } = require("utils/axios");

const getListSettingPriceCar = async (filter) => {
  try {
    const response = await axiosInstance.get(
      "/car-setting-price/getListSettingPriceCar",
      {
        params: filter,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching setting price car list:", error);
    throw error;
  }
};

const getDetailSettingPticeCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-setting-price/getDetailSettingPriceCarById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching setting price car by ID:", error);
    throw error;
  }
};

const createSellPrice = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/car-setting-price/createSellPrice",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error creating sell price:", error);
    throw error;
  }
};

const updateSellPrice = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/car-setting-price/updateSellPrice/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating sell price:", error);
    throw error;
  }
};

const SettingPriceCarService = {
  getListSettingPriceCar,
  getDetailSettingPticeCarById,
  createSellPrice,
  updateSellPrice,
};

export default SettingPriceCarService;
